// Crossing from the dashboard must request the URL from the server, so the
// same-origin proxy can select the candidate app. Initial document loads pass
// through: this also keeps the legacy fallback usable when the switch is off.
export function candidateRouteHandoff(to, from, next, navigate = path => window.location.assign(path)) {
  if (from.matched && from.matched.length) {
    // Leave router navigation pending while the document loads. Aborting with
    // next(false) rejects router.push and makes callers show a false error.
    navigate(to.fullPath)
    return
  }
  next()
}
